export default __webpack_public_path__ + "static/char-s-11-kr-f8823966bc63a81a1441c982c122f720.webp";